import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Login from "../pages/login/page";
import Register from "../pages/register/page";
import Search from "../pages/search/page";
import Report from "../pages/report/page";
import Board from "../pages/board/page";
import BoardDetail from "../pages/board/detail/page";
import BoardWrite from "../pages/board/write/page";
import BoardEdit from "../pages/board/edit/page";
import SiteDetail from "../pages/site/detail/page";
import Admin from "../pages/admin/page";
import AdminGuard from "../components/feature/AdminGuard";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/register",
    element: <Register />,
  },
  {
    path: "/search",
    element: <Search />,
  },
  {
    path: "/site/:id",
    element: <SiteDetail />,
  },
  {
    path: "/report",
    element: <Report />,
  },
  {
    path: "/board",
    element: <Board />,
  },
  {
    path: "/board/write",
    element: <BoardWrite />,
  },
  {
    path: "/board/edit/:id",
    element: <BoardEdit />,
  },
  {
    path: "/board/:id",
    element: <BoardDetail />,
  },
  {
    path: "/admin",
    element: <AdminGuard><Admin /></AdminGuard>,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;